module.exports = __webpack_public_path__ + "static/norbert-baumann-sonnen-0b32260acb9460a65b4088107fe14615.png";